import styled from 'styled-components';

import Heading, { HeadingProps } from '../Heading';

export type H2Props = Omit<HeadingProps, 'tagName'>;

const H2 = styled(Heading).attrs({
  tagName: 'h2',
})``;

H2.displayName = 'H2';

export default H2;
